<template>
  <el-dialog
    title="新建受众群体：网站访问者"
    :visible.sync="visible"
    width="600px"
    append-to-body
    :before-close="handleClose"
    class="website-visitor-dialog"
    @opened="openInit"
  >
    <div class="px-8 pb-8">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="受众群体名称：" prop="name">
          <el-input
            v-model="form.name"
            class="w-full h-12"
            placeholder="名称"
          />
        </el-form-item>

        <el-form-item label="推广站点类型：" prop="utmSourceConfig">
          <el-radio-group :value="utmSourceConfig" disabled>
            <el-radio label="GMALL3">商城3.0</el-radio>
            <el-radio label="SHOP_PLUS">商城Plus</el-radio>
            <el-radio label="SHOPLINE">shopline</el-radio>
            <el-radio label="SHOPIFY">shopify</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="站点信息：" prop="siteId">
          <el-input
            :value="`${site.id}#${site.domain}`"
            placeholder="123456"
            class="w-full h-12"
            disabled
          />
        </el-form-item>
      </el-form>

      <div class="p-4 border border-yellow-200 rounded-lg bg-yellow-100">
        <div class="flex items-start">
          <i class="el-icon-warning text-yellow-500 text-lg mr-3 mt-0.5"></i>
          <div class="text-sm text-gray-700 leading-relaxed">
            如果未安装像素将导致受众群体无法积累数据，商城 3.0 / Plus 创建受众时将会把账户的像素绑定在站点上；Shopline、Shopify 需手动安装
            <a
              href="https://alidocs.dingtalk.com/i/nodes/6LeBq413JAzKNAA6TY5mqe0x8DOnGvpb?utm_scene=person_space"
              class="text-blue-600 underline hover:text-blue-800 ml-1"
              >查看操作文档</a
            >
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        @click="sure"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { createUserList } from '@/api/google/create';
export default {
  name: 'WebsiteVisitorDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入受众群体名称', trigger: 'blur' }
        ],
        utmSourceConfig: [
        { 
            required: true, 
            validator: (rule, value, callback) => {
              if (!this.utmSourceConfig) {
                callback(new Error('请选择推广站点类型'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ],
        siteId: [
          { 
            required: true, 
            validator: (rule, value, callback) => {
              if (!this.siteId) {
                callback(new Error('请选择站点信息'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      },
    };
  },
  computed: {
    utmSourceConfig() {
      return this.data?.promoteInfo?.utmSourceConfig;
    },
    accountId() {
      return this.currentAccount?.id;
    },
    site() {
      return this.data?.promoteInfo?.site || {};
    },
    siteId() {
      return this.site?.id;
    }
  },
  mounted() {
    this.resetForm();
  },
  methods: {
    openInit(){
      // this.form.utmSourceConfig = this.data?.promoteInfo?.utmSourceConfig;
    },
    sure() {
      this.$refs.form.validate((valid) => {
        console.log('valid', valid);
        if (valid) {
          const params = {
            name: this.form.name,
            accountId: this.accountId,
            siteId: this.siteId,
            utmSourceConfig: this.utmSourceConfig,
            userListType: 'WEBSITE'
          };
          createUserList(params).then((res) => {
            this.$emit('confirm', res.data);
            this.handleClose();
          }).catch((error) => {
            console.error('创建受众群体失败:', error);
          });
        }
      });
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.resetForm();
    },
    handleConfirm() {
      this.handleClose();
    },
    resetForm() {
      this.form = {
        name: '',
      };
      this.$nextTick(() => {
        this.$refs.form?.clearValidate();
      });
    },
  },

};
</script>

<style lang="scss" scoped>
.website-visitor-dialog {
  ::v-deep .el-dialog {
    border-radius: 16px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
}
</style>
